import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "assignDelivery" }
const _hoisted_2 = { class: "assignDelivery__header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "assignDelivery__description"
}
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 1,
  class: "assignDelivery__isError"
}
const _hoisted_7 = { class: "assignDelivery__button" }
const _hoisted_8 = {
  key: 0,
  class: "assignDelivery__body"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "warning" }
const _hoisted_11 = {
  key: 1,
  class: "assignDelivery__buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.showModalAssign)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onClose: _ctx.closeModalAssign
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.isAPIReservations ? 'assignDeliveryFromDesk' : 'updateDelivery')), 1),
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModalAssign && _ctx.closeModalAssign(...args)))
              })
            ]),
            _createVNode(_component_Toggle, {
              title: _ctx.$t('chooseSeveralShelves'),
              value: _ctx.multipleShelves,
              name: "multipleShelves",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.multipleShelves = !_ctx.multipleShelves))
            }, null, 8, ["title", "value"]),
            _createVNode(_component_FormKit, {
              type: "form",
              id: "assignDelivery-form",
              modelValue: _ctx.formData,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData) = $event)),
              actions: false,
              onSubmit: _ctx.submitHandler
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Dropdown, {
                  class: _normalizeClass({
            'chooseShelf-dropdown': true,
            'chooseShelf-dropdown-error':
              _ctx.isError && _ctx.chooseShelf.selectedOption.length === 0
          }),
                  selectedOption: _ctx.chooseShelf.selectedOption,
                  options: _ctx.chooseShelf.options,
                  label: _ctx.$t('chooseShelf'),
                  multiple: _ctx.getMultipleDropdown(),
                  onSelectOption: _ctx.selectShelves
                }, null, 8, ["class", "selectedOption", "options", "label", "multiple", "onSelectOption"]),
                (_ctx.isAPIReservations)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("label", {
                        class: "label-description",
                        for: _ctx.formData.description
                      }, _toDisplayString(_ctx.$t('description')), 9, _hoisted_5),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.description) = $event)),
                        id: "description",
                        class: "input-description",
                        maxlength: "250"
                      }, "          ", 512), [
                        [_vModelText, _ctx.formData.description]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
            _ctx.isAPIReservations &&
            _ctx.isError &&
            _ctx.chooseShelf.selectedOption.length === 0
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('validation.required')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "onSubmit"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Button, {
                variant: "filled",
                title: _ctx.$t('save'),
                onClick: _ctx.submitForm
              }, null, 8, ["title", "onClick"])
            ]),
            (_ctx.isAPIReservations)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('assignDeliveryFromLocker')), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('assignToLocker')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAPIReservations)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_Button, {
                    class: "assignDelivery__buttons-redirect",
                    variant: "filled",
                    title: _ctx.$t('redirectToPickupBox'),
                    onClick: _ctx.redirectToPickupBox
                  }, null, 8, ["title", "onClick"]),
                  _createVNode(_component_Button, {
                    variant: "redBordered",
                    title: _ctx.$t('cancel'),
                    onClick: _ctx.closeModalAssign
                  }, null, 8, ["title", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}